export default __webpack_public_path__ + "static/media/thongbao.cb85045e.png";